import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  createThis2j2avj17cvnv2 as createThis,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  toString1pkumu07cwy4m as toString,
  arrayCopytctsywo3h7gj as arrayCopy,
  Unit_instanceat14thlj150z as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb252jweqlvw9s as Char__compareTo_impl_ypi4mb,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  copyOfwy6h3t5vzqpl as copyOf,
  VOID7hggqo3abtya as VOID,
  charArray2ujmm1qusno00 as charArray,
  numberToChar93r9buh19yek as numberToChar,
  concatToString3cxf0c1gqonpo as concatToString,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  concatToString2syawgu50khxi as concatToString_0,
  contentHashCode25jw6rgkgywwr as contentHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  replace3le3ie7l9k8aq as replace,
  Comparable198qfk8pnblz0 as Comparable,
  toLongw1zpgk99d84b as toLong,
  numberToLong1a4cndvg6c52s as numberToLong,
  AssertionError3yq7q0knw9m5 as AssertionError,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  isArray1hxjqtqy632bc as isArray,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  captureStack1fzi4aczwc4hg as captureStack,
  Exceptiondt2hlxn7j7vw as Exception,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    this.hdc_1 = 8192;
    this.idc_1 = 1024;
  }
}
class Segment {
  static qdc() {
    var $this = createThis(this);
    init_okio_Segment($this);
    $this.jdc_1 = new Int8Array(8192);
    $this.ndc_1 = true;
    $this.mdc_1 = false;
    return $this;
  }
  static rdc(data, pos, limit, shared, owner) {
    var $this = createThis(this);
    init_okio_Segment($this);
    $this.jdc_1 = data;
    $this.kdc_1 = pos;
    $this.ldc_1 = limit;
    $this.mdc_1 = shared;
    $this.ndc_1 = owner;
    return $this;
  }
  sdc() {
    this.mdc_1 = true;
    return Segment.rdc(this.jdc_1, this.kdc_1, this.ldc_1, true, false);
  }
  tdc() {
    var result = !(this.odc_1 === this) ? this.odc_1 : null;
    ensureNotNull(this.pdc_1).odc_1 = this.odc_1;
    ensureNotNull(this.odc_1).pdc_1 = this.pdc_1;
    this.odc_1 = null;
    this.pdc_1 = null;
    return result;
  }
  udc(segment) {
    segment.pdc_1 = this;
    segment.odc_1 = this.odc_1;
    ensureNotNull(this.odc_1).pdc_1 = segment;
    this.odc_1 = segment;
    return segment;
  }
  vdc(byteCount) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount > 0 && byteCount <= (this.ldc_1 - this.kdc_1 | 0))) {
      // Inline function 'okio.Segment.split.<anonymous>' call
      var message = 'byteCount out of range';
      throw IllegalArgumentException.l(toString(message));
    }
    var prefix;
    if (byteCount >= 1024) {
      prefix = this.sdc();
    } else {
      prefix = SegmentPool_instance.ydc();
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = this.jdc_1;
      var destination = prefix.jdc_1;
      var startIndex = this.kdc_1;
      var endIndex = this.kdc_1 + byteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, 0, startIndex, endIndex);
    }
    prefix.ldc_1 = prefix.kdc_1 + byteCount | 0;
    this.kdc_1 = this.kdc_1 + byteCount | 0;
    ensureNotNull(this.pdc_1).udc(prefix);
    return prefix;
  }
  zdc() {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!(this.pdc_1 === this)) {
      // Inline function 'okio.Segment.compact.<anonymous>' call
      var message = 'cannot compact';
      throw IllegalStateException.h5(toString(message));
    }
    if (!ensureNotNull(this.pdc_1).ndc_1)
      return Unit_instance;
    var byteCount = this.ldc_1 - this.kdc_1 | 0;
    var availableByteCount = (8192 - ensureNotNull(this.pdc_1).ldc_1 | 0) + (ensureNotNull(this.pdc_1).mdc_1 ? 0 : ensureNotNull(this.pdc_1).kdc_1) | 0;
    if (byteCount > availableByteCount)
      return Unit_instance;
    this.add(ensureNotNull(this.pdc_1), byteCount);
    this.tdc();
    SegmentPool_instance.bdd(this);
  }
  add(sink, byteCount) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!sink.ndc_1) {
      // Inline function 'okio.Segment.writeTo.<anonymous>' call
      var message = 'only owner can write';
      throw IllegalStateException.h5(toString(message));
    }
    if ((sink.ldc_1 + byteCount | 0) > 8192) {
      if (sink.mdc_1)
        throw IllegalArgumentException.re();
      if (((sink.ldc_1 + byteCount | 0) - sink.kdc_1 | 0) > 8192)
        throw IllegalArgumentException.re();
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = sink.jdc_1;
      var destination = sink.jdc_1;
      var startIndex = sink.kdc_1;
      var endIndex = sink.ldc_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, 0, startIndex, endIndex);
      sink.ldc_1 = sink.ldc_1 - sink.kdc_1 | 0;
      sink.kdc_1 = 0;
    }
    // Inline function 'kotlin.collections.copyInto' call
    var this_1 = this.jdc_1;
    var destination_0 = sink.jdc_1;
    var destinationOffset = sink.ldc_1;
    var startIndex_0 = this.kdc_1;
    var endIndex_0 = this.kdc_1 + byteCount | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = this_1;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp_0, destination_0, destinationOffset, startIndex_0, endIndex_0);
    sink.ldc_1 = sink.ldc_1 + byteCount | 0;
    this.kdc_1 = this.kdc_1 + byteCount | 0;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$0 = new Int8Array([]);
    tmp.rdd_1 = new ByteString(tmp$ret$0);
  }
  sdd(_this__u8e3s4) {
    // Inline function 'okio.internal.commonEncodeUtf8' call
    var byteString = new ByteString(asUtf8ToByteArray(_this__u8e3s4));
    byteString.tdd(_this__u8e3s4);
    return byteString;
  }
}
class ByteString {
  constructor(data) {
    Companion_getInstance_0();
    this.cdd_1 = data;
    this.ddd_1 = 0;
    this.edd_1 = null;
  }
  udd(value) {
  }
  tdd(value) {
  }
  vdd() {
    // Inline function 'okio.internal.commonUtf8' call
    var result = this.edd_1;
    if (result == null) {
      result = toUtf8String(this.wdd());
      this.tdd(result);
    }
    return result;
  }
  xdd() {
    // Inline function 'okio.internal.commonHex' call
    var result = charArray(imul(this.cdd_1.length, 2));
    var c = 0;
    var indexedObject = this.cdd_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var b = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp1 = c;
      c = tmp1 + 1 | 0;
      var tmp = get_HEX_DIGIT_CHARS();
      // Inline function 'okio.shr' call
      result[tmp1] = tmp[b >> 4 & 15];
      var tmp2 = c;
      c = tmp2 + 1 | 0;
      var tmp_0 = get_HEX_DIGIT_CHARS();
      // Inline function 'okio.and' call
      result[tmp2] = tmp_0[b & 15];
    }
    return concatToString_0(result);
  }
  ydd(pos) {
    if (pos >= this.g1() || pos < 0)
      throw ArrayIndexOutOfBoundsException.jdd('size=' + this.g1() + ' pos=' + pos);
    // Inline function 'okio.internal.commonGetByte' call
    return this.cdd_1[pos];
  }
  h1(index) {
    return this.ydd(index);
  }
  g1() {
    return this.zdd();
  }
  zdd() {
    // Inline function 'okio.internal.commonGetSize' call
    return this.cdd_1.length;
  }
  wdd() {
    // Inline function 'okio.internal.commonInternalArray' call
    return this.cdd_1;
  }
  ade(buffer, offset, byteCount) {
    return commonWrite(this, buffer, offset, byteCount);
  }
  bde(offset, other, otherOffset, byteCount) {
    // Inline function 'okio.internal.commonRangeEquals' call
    return offset >= 0 && offset <= (this.cdd_1.length - byteCount | 0) && otherOffset >= 0 && otherOffset <= (other.length - byteCount | 0) && arrayRangeEquals(this.cdd_1, offset, other, otherOffset, byteCount);
  }
  equals(other) {
    // Inline function 'okio.internal.commonEquals' call
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      if (other instanceof ByteString) {
        tmp = (other.g1() === this.cdd_1.length && other.bde(0, this.cdd_1, 0, this.cdd_1.length));
      } else {
        tmp = false;
      }
    }
    return tmp;
  }
  hashCode() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonHashCode' call
      var result = this.ddd_1;
      if (!(result === 0)) {
        tmp$ret$0 = result;
        break $l$block;
      }
      // Inline function 'kotlin.also' call
      var this_0 = contentHashCode(this.cdd_1);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'okio.internal.commonHashCode.<anonymous>' call
      this.udd(this_0);
      tmp$ret$0 = this_0;
    }
    return tmp$ret$0;
  }
  cde(other) {
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'okio.internal.commonCompareTo' call
      var sizeA = this.g1();
      var sizeB = other.g1();
      var i = 0;
      // Inline function 'kotlin.comparisons.minOf' call
      var size = Math.min(sizeA, sizeB);
      $l$loop: while (i < size) {
        // Inline function 'okio.and' call
        var byteA = this.h1(i) & 255;
        // Inline function 'okio.and' call
        var byteB = other.h1(i) & 255;
        if (byteA === byteB) {
          i = i + 1 | 0;
          continue $l$loop;
        }
        tmp$ret$3 = byteA < byteB ? -1 : 1;
        break $l$block_0;
      }
      if (sizeA === sizeB) {
        tmp$ret$3 = 0;
        break $l$block_0;
      }
      tmp$ret$3 = sizeA < sizeB ? -1 : 1;
    }
    return tmp$ret$3;
  }
  d(other) {
    return this.cde(other instanceof ByteString ? other : THROW_CCE());
  }
  toString() {
    var tmp$ret$1;
    $l$block_1: {
      // Inline function 'okio.internal.commonToString' call
      // Inline function 'kotlin.collections.isEmpty' call
      if (this.cdd_1.length === 0) {
        tmp$ret$1 = '[size=0]';
        break $l$block_1;
      }
      var i = codePointIndexToCharIndex$accessor$1yfvj6b(this.cdd_1, 64);
      if (i === -1) {
        var tmp;
        if (this.cdd_1.length <= 64) {
          tmp = '[hex=' + this.xdd() + ']';
        } else {
          var tmp_0 = this.cdd_1.length;
          var tmp$ret$5;
          $l$block_0: {
            // Inline function 'okio.internal.commonSubstring' call
            var endIndex = resolveDefaultParameter(this, 64);
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(0 >= 0)) {
              // Inline function 'okio.internal.commonSubstring.<anonymous>' call
              var message = 'beginIndex < 0';
              throw IllegalArgumentException.l(toString(message));
            }
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(endIndex <= this.cdd_1.length)) {
              // Inline function 'okio.internal.commonSubstring.<anonymous>' call
              var message_0 = 'endIndex > length(' + this.cdd_1.length + ')';
              throw IllegalArgumentException.l(toString(message_0));
            }
            var subLen = endIndex - 0 | 0;
            // Inline function 'kotlin.require' call
            // Inline function 'kotlin.contracts.contract' call
            if (!(subLen >= 0)) {
              // Inline function 'okio.internal.commonSubstring.<anonymous>' call
              var message_1 = 'endIndex < beginIndex';
              throw IllegalArgumentException.l(toString(message_1));
            }
            if (0 === 0 && endIndex === this.cdd_1.length) {
              tmp$ret$5 = this;
              break $l$block_0;
            }
            tmp$ret$5 = new ByteString(copyOfRange(this.cdd_1, 0, endIndex));
          }
          tmp = '[size=' + tmp_0 + ' hex=' + tmp$ret$5.xdd() + '\u2026]';
        }
        tmp$ret$1 = tmp;
        break $l$block_1;
      }
      var text = this.vdd();
      // Inline function 'kotlin.text.substring' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$7 = text.substring(0, i);
      var safeText = replace(replace(replace(tmp$ret$7, '\\', '\\\\'), '\n', '\\n'), '\r', '\\r');
      var tmp_1;
      if (i < text.length) {
        tmp_1 = '[size=' + this.cdd_1.length + ' text=' + safeText + '\u2026]';
      } else {
        tmp_1 = '[text=' + safeText + ']';
      }
      tmp$ret$1 = tmp_1;
    }
    return tmp$ret$1;
  }
}
class SegmentedByteString extends ByteString {
  constructor(segments, directory) {
    super(Companion_getInstance_0().rdd_1.cdd_1);
    this.pdd_1 = segments;
    this.qdd_1 = directory;
  }
  xdd() {
    return toByteString(this).xdd();
  }
  ydd(pos) {
    // Inline function 'okio.internal.commonInternalGet' call
    checkOffsetAndCount(toLong(this.qdd_1[this.pdd_1.length - 1 | 0]), toLong(pos), new Long(1, 0));
    var segment_0 = segment(this, pos);
    var segmentOffset = segment_0 === 0 ? 0 : this.qdd_1[segment_0 - 1 | 0];
    var segmentPos = this.qdd_1[segment_0 + this.pdd_1.length | 0];
    return this.pdd_1[segment_0][(pos - segmentOffset | 0) + segmentPos | 0];
  }
  zdd() {
    // Inline function 'okio.internal.commonGetSize' call
    return this.qdd_1[this.pdd_1.length - 1 | 0];
  }
  v22() {
    // Inline function 'okio.internal.commonToByteArray' call
    var result = new Int8Array(this.g1());
    var resultPos = 0;
    // Inline function 'okio.internal.forEachSegment' call
    var segmentCount = this.pdd_1.length;
    var s = 0;
    var pos = 0;
    while (s < segmentCount) {
      var segmentPos = this.qdd_1[segmentCount + s | 0];
      var nextSegmentOffset = this.qdd_1[s];
      // Inline function 'okio.internal.commonToByteArray.<anonymous>' call
      var byteCount = nextSegmentOffset - pos | 0;
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = this.pdd_1[s];
      var destinationOffset = resultPos;
      var endIndex = segmentPos + byteCount | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, result, destinationOffset, segmentPos, endIndex);
      resultPos = resultPos + byteCount | 0;
      pos = nextSegmentOffset;
      s = s + 1 | 0;
    }
    return result;
  }
  ade(buffer, offset, byteCount) {
    // Inline function 'okio.internal.forEachSegment' call
    var endIndex = offset + byteCount | 0;
    var s = segment(this, offset);
    var pos = offset;
    while (pos < endIndex) {
      var segmentOffset = s === 0 ? 0 : this.qdd_1[s - 1 | 0];
      var segmentSize = this.qdd_1[s] - segmentOffset | 0;
      var segmentPos = this.qdd_1[this.pdd_1.length + s | 0];
      // Inline function 'kotlin.comparisons.minOf' call
      var b = segmentOffset + segmentSize | 0;
      var byteCount_0 = Math.min(endIndex, b) - pos | 0;
      var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
      // Inline function 'okio.internal.commonWrite.<anonymous>' call
      var data = this.pdd_1[s];
      var segment_0 = Segment.rdc(data, offset_0, offset_0 + byteCount_0 | 0, true, false);
      if (buffer.kdd_1 == null) {
        segment_0.pdc_1 = segment_0;
        segment_0.odc_1 = segment_0.pdc_1;
        buffer.kdd_1 = segment_0.odc_1;
      } else {
        ensureNotNull(ensureNotNull(buffer.kdd_1).pdc_1).udc(segment_0);
      }
      pos = pos + byteCount_0 | 0;
      s = s + 1 | 0;
    }
    var tmp = buffer;
    // Inline function 'kotlin.Long.plus' call
    tmp.ldd_1 = buffer.ldd_1.w3(toLong(byteCount));
    return Unit_instance;
  }
  dde(offset, other, otherOffset, byteCount) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonRangeEquals' call
      if (offset < 0 || offset > (this.g1() - byteCount | 0)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var otherOffset_0 = otherOffset;
      // Inline function 'okio.internal.forEachSegment' call
      var endIndex = offset + byteCount | 0;
      var s = segment(this, offset);
      var pos = offset;
      while (pos < endIndex) {
        var segmentOffset = s === 0 ? 0 : this.qdd_1[s - 1 | 0];
        var segmentSize = this.qdd_1[s] - segmentOffset | 0;
        var segmentPos = this.qdd_1[this.pdd_1.length + s | 0];
        // Inline function 'kotlin.comparisons.minOf' call
        var b = segmentOffset + segmentSize | 0;
        var byteCount_0 = Math.min(endIndex, b) - pos | 0;
        var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
        // Inline function 'okio.internal.commonRangeEquals.<anonymous>' call
        var data = this.pdd_1[s];
        if (!other.bde(otherOffset_0, data, offset_0, byteCount_0)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
        pos = pos + byteCount_0 | 0;
        s = s + 1 | 0;
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  bde(offset, other, otherOffset, byteCount) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'okio.internal.commonRangeEquals' call
      if (offset < 0 || offset > (this.g1() - byteCount | 0) || otherOffset < 0 || otherOffset > (other.length - byteCount | 0)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var otherOffset_0 = otherOffset;
      // Inline function 'okio.internal.forEachSegment' call
      var endIndex = offset + byteCount | 0;
      var s = segment(this, offset);
      var pos = offset;
      while (pos < endIndex) {
        var segmentOffset = s === 0 ? 0 : this.qdd_1[s - 1 | 0];
        var segmentSize = this.qdd_1[s] - segmentOffset | 0;
        var segmentPos = this.qdd_1[this.pdd_1.length + s | 0];
        // Inline function 'kotlin.comparisons.minOf' call
        var b = segmentOffset + segmentSize | 0;
        var byteCount_0 = Math.min(endIndex, b) - pos | 0;
        var offset_0 = segmentPos + (pos - segmentOffset | 0) | 0;
        // Inline function 'okio.internal.commonRangeEquals.<anonymous>' call
        var data = this.pdd_1[s];
        if (!arrayRangeEquals(data, offset_0, other, otherOffset_0, byteCount_0)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        otherOffset_0 = otherOffset_0 + byteCount_0 | 0;
        pos = pos + byteCount_0 | 0;
        s = s + 1 | 0;
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  wdd() {
    return this.v22();
  }
  equals(other) {
    // Inline function 'okio.internal.commonEquals' call
    var tmp;
    if (other === this) {
      tmp = true;
    } else {
      if (other instanceof ByteString) {
        tmp = (other.g1() === this.g1() && this.dde(0, other, 0, this.g1()));
      } else {
        tmp = false;
      }
    }
    return tmp;
  }
  hashCode() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonHashCode' call
      var result = this.ddd_1;
      if (!(result === 0)) {
        tmp$ret$0 = result;
        break $l$block;
      }
      result = 1;
      // Inline function 'okio.internal.forEachSegment' call
      var segmentCount = this.pdd_1.length;
      var s = 0;
      var pos = 0;
      while (s < segmentCount) {
        var segmentPos = this.qdd_1[segmentCount + s | 0];
        var nextSegmentOffset = this.qdd_1[s];
        // Inline function 'okio.internal.commonHashCode.<anonymous>' call
        var data = this.pdd_1[s];
        var i = segmentPos;
        var limit = segmentPos + (nextSegmentOffset - pos | 0) | 0;
        while (i < limit) {
          result = imul(31, result) + data[i] | 0;
          i = i + 1 | 0;
        }
        pos = nextSegmentOffset;
        s = s + 1 | 0;
      }
      this.udd(result);
      tmp$ret$0 = result;
    }
    return tmp$ret$0;
  }
  toString() {
    return toByteString(this).toString();
  }
}
class UnsafeCursor {
  constructor() {
    this.ede_1 = null;
    this.fde_1 = false;
    this.gde_1 = null;
    this.hde_1 = new Long(-1, -1);
    this.ide_1 = null;
    this.jde_1 = -1;
    this.kde_1 = -1;
  }
}
class BufferedSource {}
class Buffer {
  constructor() {
    this.kdd_1 = null;
    this.ldd_1 = new Long(0, 0);
  }
  lde() {
    return this.mde(this.ldd_1);
  }
  mde(byteCount) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'okio.internal.commonReadUtf8' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(byteCount.b2(new Long(0, 0)) >= 0 && byteCount.b2(new Long(2147483647, 0)) <= 0)) {
        // Inline function 'okio.internal.commonReadUtf8.<anonymous>' call
        var message = 'byteCount: ' + byteCount.toString();
        throw IllegalArgumentException.l(toString(message));
      }
      if (this.ldd_1.b2(byteCount) < 0)
        throw EOFException.qde();
      if (byteCount.equals(new Long(0, 0))) {
        tmp$ret$1 = '';
        break $l$block_0;
      }
      var s = ensureNotNull(this.kdd_1);
      if (numberToLong(s.kdc_1).w3(byteCount).b2(toLong(s.ldc_1)) > 0) {
        tmp$ret$1 = commonToUtf8String(this.rde(byteCount));
        break $l$block_0;
      }
      var result = commonToUtf8String(s.jdc_1, s.kdc_1, s.kdc_1 + byteCount.l2() | 0);
      s.kdc_1 = s.kdc_1 + byteCount.l2() | 0;
      this.ldd_1 = this.ldd_1.c2(byteCount);
      if (s.kdc_1 === s.ldc_1) {
        this.kdd_1 = s.tdc();
        SegmentPool_instance.bdd(s);
      }
      tmp$ret$1 = result;
    }
    return tmp$ret$1;
  }
  sde() {
    // Inline function 'okio.internal.commonReadByteArray' call
    return this.rde(this.ldd_1);
  }
  rde(byteCount) {
    // Inline function 'okio.internal.commonReadByteArray' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(byteCount.b2(new Long(0, 0)) >= 0 && byteCount.b2(new Long(2147483647, 0)) <= 0)) {
      // Inline function 'okio.internal.commonReadByteArray.<anonymous>' call
      var message = 'byteCount: ' + byteCount.toString();
      throw IllegalArgumentException.l(toString(message));
    }
    if (this.ldd_1.b2(byteCount) < 0)
      throw EOFException.qde();
    var result = new Int8Array(byteCount.l2());
    this.tde(result);
    return result;
  }
  tde(sink) {
    var offset = 0;
    while (offset < sink.length) {
      var read = this.w2d(sink, offset, sink.length - offset | 0);
      if (read === -1)
        throw EOFException.qde();
      offset = offset + read | 0;
    }
    return Unit_instance;
  }
  w2d(sink, offset, byteCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonRead' call
      checkOffsetAndCount(toLong(sink.length), toLong(offset), toLong(byteCount));
      var tmp0_elvis_lhs = this.kdd_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = -1;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var s = tmp;
      // Inline function 'kotlin.comparisons.minOf' call
      var b = s.ldc_1 - s.kdc_1 | 0;
      var toCopy = Math.min(byteCount, b);
      // Inline function 'kotlin.collections.copyInto' call
      var this_0 = s.jdc_1;
      var startIndex = s.kdc_1;
      var endIndex = s.kdc_1 + toCopy | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp_0 = this_0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp_0, sink, offset, startIndex, endIndex);
      s.kdc_1 = s.kdc_1 + toCopy | 0;
      this.ldd_1 = this.ldd_1.c2(toLong(toCopy));
      if (s.kdc_1 === s.ldc_1) {
        this.kdd_1 = s.tdc();
        SegmentPool_instance.bdd(s);
      }
      tmp$ret$0 = toCopy;
    }
    return tmp$ret$0;
  }
  ude(byteString) {
    // Inline function 'okio.internal.commonWrite' call
    var byteCount = byteString.g1();
    byteString.ade(this, 0, byteCount);
    return this;
  }
  vde(minimumCapacity) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'okio.internal.commonWritableSegment' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
        // Inline function 'okio.internal.commonWritableSegment.<anonymous>' call
        var message = 'unexpected capacity';
        throw IllegalArgumentException.l(toString(message));
      }
      if (this.kdd_1 == null) {
        var result = SegmentPool_instance.ydc();
        this.kdd_1 = result;
        result.pdc_1 = result;
        result.odc_1 = result;
        tmp$ret$1 = result;
        break $l$block;
      }
      var tail = ensureNotNull(this.kdd_1).pdc_1;
      if ((ensureNotNull(tail).ldc_1 + minimumCapacity | 0) > 8192 || !tail.ndc_1) {
        tail = tail.udc(SegmentPool_instance.ydc());
      }
      tmp$ret$1 = tail;
    }
    return tmp$ret$1;
  }
  wde(string) {
    return this.xde(string, 0, string.length);
  }
  xde(string, beginIndex, endIndex) {
    // Inline function 'okio.internal.commonWriteUtf8' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(beginIndex >= 0)) {
      // Inline function 'okio.internal.commonWriteUtf8.<anonymous>' call
      var message = 'beginIndex < 0: ' + beginIndex;
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(endIndex >= beginIndex)) {
      // Inline function 'okio.internal.commonWriteUtf8.<anonymous>' call
      var message_0 = 'endIndex < beginIndex: ' + endIndex + ' < ' + beginIndex;
      throw IllegalArgumentException.l(toString(message_0));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(endIndex <= string.length)) {
      // Inline function 'okio.internal.commonWriteUtf8.<anonymous>' call
      var message_1 = 'endIndex > string.length: ' + endIndex + ' > ' + string.length;
      throw IllegalArgumentException.l(toString(message_1));
    }
    var i = beginIndex;
    while (i < endIndex) {
      // Inline function 'kotlin.code' call
      var this_0 = charSequenceGet(string, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < 128) {
        var tail = this.vde(1);
        var data = tail.jdc_1;
        var segmentOffset = tail.ldc_1 - i | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = 8192 - segmentOffset | 0;
        var runLimit = Math.min(endIndex, b);
        var tmp0 = i;
        i = tmp0 + 1 | 0;
        data[segmentOffset + tmp0 | 0] = toByte(c);
        $l$loop: while (i < runLimit) {
          // Inline function 'kotlin.code' call
          var this_1 = charSequenceGet(string, i);
          c = Char__toInt_impl_vasixd(this_1);
          if (c >= 128)
            break $l$loop;
          var tmp1 = i;
          i = tmp1 + 1 | 0;
          data[segmentOffset + tmp1 | 0] = toByte(c);
        }
        var runSize = (i + segmentOffset | 0) - tail.ldc_1 | 0;
        tail.ldc_1 = tail.ldc_1 + runSize | 0;
        this.ldd_1 = this.ldd_1.w3(toLong(runSize));
      } else if (c < 2048) {
        var tail_0 = this.vde(2);
        tail_0.jdc_1[tail_0.ldc_1] = toByte(c >> 6 | 192);
        tail_0.jdc_1[tail_0.ldc_1 + 1 | 0] = toByte(c & 63 | 128);
        tail_0.ldc_1 = tail_0.ldc_1 + 2 | 0;
        this.ldd_1 = this.ldd_1.w3(new Long(2, 0));
        i = i + 1 | 0;
      } else if (c < 55296 || c > 57343) {
        var tail_1 = this.vde(3);
        tail_1.jdc_1[tail_1.ldc_1] = toByte(c >> 12 | 224);
        tail_1.jdc_1[tail_1.ldc_1 + 1 | 0] = toByte(c >> 6 & 63 | 128);
        tail_1.jdc_1[tail_1.ldc_1 + 2 | 0] = toByte(c & 63 | 128);
        tail_1.ldc_1 = tail_1.ldc_1 + 3 | 0;
        this.ldd_1 = this.ldd_1.w3(new Long(3, 0));
        i = i + 1 | 0;
      } else {
        var tmp;
        if ((i + 1 | 0) < endIndex) {
          // Inline function 'kotlin.code' call
          var this_2 = charSequenceGet(string, i + 1 | 0);
          tmp = Char__toInt_impl_vasixd(this_2);
        } else {
          tmp = 0;
        }
        var low = tmp;
        if (c > 56319 || !(56320 <= low ? low <= 57343 : false)) {
          // Inline function 'kotlin.code' call
          var this_3 = _Char___init__impl__6a9atx(63);
          var tmp$ret$7 = Char__toInt_impl_vasixd(this_3);
          this.yde(tmp$ret$7);
          i = i + 1 | 0;
        } else {
          var codePoint = 65536 + ((c & 1023) << 10 | low & 1023) | 0;
          var tail_2 = this.vde(4);
          tail_2.jdc_1[tail_2.ldc_1] = toByte(codePoint >> 18 | 240);
          tail_2.jdc_1[tail_2.ldc_1 + 1 | 0] = toByte(codePoint >> 12 & 63 | 128);
          tail_2.jdc_1[tail_2.ldc_1 + 2 | 0] = toByte(codePoint >> 6 & 63 | 128);
          tail_2.jdc_1[tail_2.ldc_1 + 3 | 0] = toByte(codePoint & 63 | 128);
          tail_2.ldc_1 = tail_2.ldc_1 + 4 | 0;
          this.ldd_1 = this.ldd_1.w3(new Long(4, 0));
          i = i + 2 | 0;
        }
      }
    }
    return this;
  }
  v2d(source, offset, byteCount) {
    // Inline function 'okio.internal.commonWrite' call
    var offset_0 = offset;
    checkOffsetAndCount(toLong(source.length), toLong(offset_0), toLong(byteCount));
    var limit = offset_0 + byteCount | 0;
    while (offset_0 < limit) {
      var tail = this.vde(1);
      // Inline function 'kotlin.comparisons.minOf' call
      var a = limit - offset_0 | 0;
      var b = 8192 - tail.ldc_1 | 0;
      var toCopy = Math.min(a, b);
      // Inline function 'kotlin.collections.copyInto' call
      var destination = tail.jdc_1;
      var destinationOffset = tail.ldc_1;
      var startIndex = offset_0;
      var endIndex = offset_0 + toCopy | 0;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = source;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, destination, destinationOffset, startIndex, endIndex);
      offset_0 = offset_0 + toCopy | 0;
      tail.ldc_1 = tail.ldc_1 + toCopy | 0;
    }
    this.ldd_1 = this.ldd_1.w3(toLong(byteCount));
    return this;
  }
  zde(source) {
    // Inline function 'okio.internal.commonWriteAll' call
    var totalBytesRead = new Long(0, 0);
    $l$loop: while (true) {
      var readCount = source.adf(this, new Long(8192, 0));
      if (readCount.equals(new Long(-1, -1)))
        break $l$loop;
      totalBytesRead = totalBytesRead.w3(readCount);
    }
    return totalBytesRead;
  }
  yde(b) {
    // Inline function 'okio.internal.commonWriteByte' call
    var tail = this.vde(1);
    var tmp1 = tail.ldc_1;
    tail.ldc_1 = tmp1 + 1 | 0;
    tail.jdc_1[tmp1] = toByte(b);
    this.ldd_1 = this.ldd_1.w3(new Long(1, 0));
    return this;
  }
  bdf(source, byteCount) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'okio.internal.commonWrite' call
      var byteCount_0 = byteCount;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!!(source === this)) {
        // Inline function 'okio.internal.commonWrite.<anonymous>' call
        var message = 'source == this';
        throw IllegalArgumentException.l(toString(message));
      }
      checkOffsetAndCount(source.ldd_1, new Long(0, 0), byteCount_0);
      while (byteCount_0.b2(new Long(0, 0)) > 0) {
        if (byteCount_0.b2(toLong(ensureNotNull(source.kdd_1).ldc_1 - ensureNotNull(source.kdd_1).kdc_1 | 0)) < 0) {
          var tail = !(this.kdd_1 == null) ? ensureNotNull(this.kdd_1).pdc_1 : null;
          var tmp;
          if (!(tail == null) && tail.ndc_1) {
            // Inline function 'kotlin.Long.minus' call
            // Inline function 'kotlin.Long.plus' call
            var this_0 = byteCount_0;
            var other = tail.ldc_1;
            var this_1 = this_0.w3(toLong(other));
            var other_0 = tail.mdc_1 ? 0 : tail.kdc_1;
            tmp = this_1.c2(toLong(other_0)).b2(new Long(8192, 0)) <= 0;
          } else {
            tmp = false;
          }
          if (tmp) {
            ensureNotNull(source.kdd_1).add(tail, byteCount_0.l2());
            source.ldd_1 = source.ldd_1.c2(byteCount_0);
            this.ldd_1 = this.ldd_1.w3(byteCount_0);
            tmp$ret$3 = Unit_instance;
            break $l$block;
          } else {
            source.kdd_1 = ensureNotNull(source.kdd_1).vdc(byteCount_0.l2());
          }
        }
        var segmentToMove = source.kdd_1;
        var movedByteCount = toLong(ensureNotNull(segmentToMove).ldc_1 - segmentToMove.kdc_1 | 0);
        source.kdd_1 = segmentToMove.tdc();
        if (this.kdd_1 == null) {
          this.kdd_1 = segmentToMove;
          segmentToMove.pdc_1 = segmentToMove;
          segmentToMove.odc_1 = segmentToMove.pdc_1;
        } else {
          var tail_0 = ensureNotNull(this.kdd_1).pdc_1;
          tail_0 = ensureNotNull(tail_0).udc(segmentToMove);
          tail_0.zdc();
        }
        source.ldd_1 = source.ldd_1.c2(movedByteCount);
        this.ldd_1 = this.ldd_1.w3(movedByteCount);
        byteCount_0 = byteCount_0.c2(movedByteCount);
      }
    }
    return tmp$ret$3;
  }
  adf(sink, byteCount) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'okio.internal.commonRead' call
      var byteCount_0 = byteCount;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(byteCount_0.b2(new Long(0, 0)) >= 0)) {
        // Inline function 'okio.internal.commonRead.<anonymous>' call
        var message = 'byteCount < 0: ' + byteCount_0.toString();
        throw IllegalArgumentException.l(toString(message));
      }
      if (this.ldd_1.equals(new Long(0, 0))) {
        tmp$ret$1 = new Long(-1, -1);
        break $l$block;
      }
      if (byteCount_0.b2(this.ldd_1) > 0)
        byteCount_0 = this.ldd_1;
      sink.bdf(this, byteCount_0);
      tmp$ret$1 = byteCount_0;
    }
    return tmp$ret$1;
  }
  gd() {
    return Unit_instance;
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_3: {
      // Inline function 'okio.internal.commonEquals' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_3;
      }
      if (!(other instanceof Buffer)) {
        tmp$ret$0 = false;
        break $l$block_3;
      }
      if (!this.ldd_1.equals(other.ldd_1)) {
        tmp$ret$0 = false;
        break $l$block_3;
      }
      if (this.ldd_1.equals(new Long(0, 0))) {
        tmp$ret$0 = true;
        break $l$block_3;
      }
      var sa = ensureNotNull(this.kdd_1);
      var sb = ensureNotNull(other.kdd_1);
      var posA = sa.kdc_1;
      var posB = sb.kdc_1;
      var pos = new Long(0, 0);
      var count;
      while (pos.b2(this.ldd_1) < 0) {
        // Inline function 'kotlin.comparisons.minOf' call
        var a = sa.ldc_1 - posA | 0;
        var b = sb.ldc_1 - posB | 0;
        var tmp$ret$1 = Math.min(a, b);
        count = toLong(tmp$ret$1);
        var inductionVariable = new Long(0, 0);
        if (inductionVariable.b2(count) < 0)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable.w3(new Long(1, 0));
            var tmp = sa.jdc_1;
            var tmp1 = posA;
            posA = tmp1 + 1 | 0;
            var tmp_0 = tmp[tmp1];
            var tmp_1 = sb.jdc_1;
            var tmp2 = posB;
            posB = tmp2 + 1 | 0;
            if (!(tmp_0 === tmp_1[tmp2])) {
              tmp$ret$0 = false;
              break $l$block_3;
            }
          }
           while (inductionVariable.b2(count) < 0);
        if (posA === sa.ldc_1) {
          sa = ensureNotNull(sa.odc_1);
          posA = sa.kdc_1;
        }
        if (posB === sb.ldc_1) {
          sb = ensureNotNull(sb.odc_1);
          posB = sb.kdc_1;
        }
        pos = pos.w3(count);
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonHashCode' call
      var tmp0_elvis_lhs = this.kdd_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$0 = 0;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var s = tmp;
      var result = 1;
      do {
        var pos = s.kdc_1;
        var limit = s.ldc_1;
        while (pos < limit) {
          result = imul(31, result) + s.jdc_1[pos] | 0;
          pos = pos + 1 | 0;
        }
        s = ensureNotNull(s.odc_1);
      }
       while (!(s === this.kdd_1));
      tmp$ret$0 = result;
    }
    return tmp$ret$0;
  }
  toString() {
    return this.t20().toString();
  }
  t20() {
    // Inline function 'okio.internal.commonSnapshot' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.ldd_1.b2(new Long(2147483647, 0)) <= 0)) {
      // Inline function 'okio.internal.commonSnapshot.<anonymous>' call
      var message = 'size > Int.MAX_VALUE: ' + this.ldd_1.toString();
      throw IllegalStateException.h5(toString(message));
    }
    return this.cdf(this.ldd_1.l2());
  }
  cdf(byteCount) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'okio.internal.commonSnapshot' call
      if (byteCount === 0) {
        tmp$ret$0 = Companion_getInstance_0().rdd_1;
        break $l$block;
      }
      checkOffsetAndCount(this.ldd_1, new Long(0, 0), toLong(byteCount));
      var offset = 0;
      var segmentCount = 0;
      var s = this.kdd_1;
      while (offset < byteCount) {
        if (ensureNotNull(s).ldc_1 === s.kdc_1) {
          throw AssertionError.of('s.limit == s.pos');
        }
        offset = offset + (s.ldc_1 - s.kdc_1 | 0) | 0;
        segmentCount = segmentCount + 1 | 0;
        s = s.odc_1;
      }
      // Inline function 'kotlin.arrayOfNulls' call
      var size = segmentCount;
      var segments = fillArrayVal(Array(size), null);
      var directory = new Int32Array(imul(segmentCount, 2));
      offset = 0;
      segmentCount = 0;
      s = this.kdd_1;
      while (offset < byteCount) {
        segments[segmentCount] = ensureNotNull(s).jdc_1;
        offset = offset + (s.ldc_1 - s.kdc_1 | 0) | 0;
        var tmp = segmentCount;
        // Inline function 'kotlin.comparisons.minOf' call
        var a = offset;
        directory[tmp] = Math.min(a, byteCount);
        directory[segmentCount + segments.length | 0] = s.kdc_1;
        s.mdc_1 = true;
        segmentCount = segmentCount + 1 | 0;
        s = s.odc_1;
      }
      tmp$ret$0 = new SegmentedByteString(isArray(segments) ? segments : THROW_CCE(), directory);
    }
    return tmp$ret$0;
  }
}
class ArrayIndexOutOfBoundsException extends IndexOutOfBoundsException {
  static jdd(message) {
    var $this = this.ze(message);
    captureStack($this, $this.idd_1);
    return $this;
  }
}
class IOException extends Exception {
  static hdf(message, cause) {
    var $this = this.pe(message, cause);
    captureStack($this, $this.fdf_1);
    return $this;
  }
  static gdf(message) {
    return this.hdf(message, null);
  }
  static idf() {
    return this.hdf(null, null);
  }
}
class EOFException extends IOException {
  static ddf(message) {
    var $this = this.gdf(message);
    captureStack($this, $this.pde_1);
    return $this;
  }
  static qde() {
    return this.ddf(null);
  }
}
class RealBufferedSource {
  constructor(source) {
    this.jdf_1 = source;
    this.kdf_1 = false;
    this.ldf_1 = new Buffer();
  }
  adf(sink, byteCount) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'okio.internal.commonRead' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(byteCount.b2(new Long(0, 0)) >= 0)) {
        // Inline function 'okio.internal.commonRead.<anonymous>' call
        var message = 'byteCount < 0: ' + byteCount.toString();
        throw IllegalArgumentException.l(toString(message));
      }
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!!this.kdf_1) {
        // Inline function 'okio.internal.commonRead.<anonymous>' call
        var message_0 = 'closed';
        throw IllegalStateException.h5(toString(message_0));
      }
      if (this.ldf_1.ldd_1.equals(new Long(0, 0))) {
        var read = this.jdf_1.adf(this.ldf_1, new Long(8192, 0));
        if (read.equals(new Long(-1, -1))) {
          tmp$ret$2 = new Long(-1, -1);
          break $l$block;
        }
      }
      // Inline function 'kotlin.comparisons.minOf' call
      var b = this.ldf_1.ldd_1;
      var toRead = byteCount.b2(b) <= 0 ? byteCount : b;
      tmp$ret$2 = this.ldf_1.adf(sink, toRead);
    }
    return tmp$ret$2;
  }
  lde() {
    // Inline function 'okio.internal.commonReadUtf8' call
    this.ldf_1.zde(this.jdf_1);
    return this.ldf_1.lde();
  }
  toString() {
    // Inline function 'okio.internal.commonToString' call
    return 'buffer(' + toString(this.jdf_1) + ')';
  }
}
class SegmentPool {
  constructor() {
    this.wdc_1 = 0;
    this.xdc_1 = 0;
  }
  ydc() {
    return Segment.qdc();
  }
  bdd(segment) {
  }
}
//endregion
function buffer(_this__u8e3s4) {
  return new RealBufferedSource(_this__u8e3s4);
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function init_okio_Segment(_this__u8e3s4) {
  _this__u8e3s4.kdc_1 = 0;
  _this__u8e3s4.ldc_1 = 0;
  _this__u8e3s4.mdc_1 = false;
  _this__u8e3s4.ndc_1 = false;
  _this__u8e3s4.odc_1 = null;
  _this__u8e3s4.pdc_1 = null;
}
var DEFAULT__new_UnsafeCursor;
function get_DEFAULT__ByteString_size() {
  _init_properties_Util_kt__laey5a();
  return DEFAULT__ByteString_size;
}
var DEFAULT__ByteString_size;
function resolveDefaultParameter(_this__u8e3s4, position) {
  _init_properties_Util_kt__laey5a();
  if (position === get_DEFAULT__ByteString_size())
    return _this__u8e3s4.g1();
  return position;
}
function arrayRangeEquals(a, aOffset, b, bOffset, byteCount) {
  _init_properties_Util_kt__laey5a();
  var inductionVariable = 0;
  if (inductionVariable < byteCount)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(a[i + aOffset | 0] === b[i + bOffset | 0]))
        return false;
    }
     while (inductionVariable < byteCount);
  return true;
}
function checkOffsetAndCount(size, offset, byteCount) {
  _init_properties_Util_kt__laey5a();
  if (offset.i4(byteCount).b2(new Long(0, 0)) < 0 || offset.b2(size) > 0 || size.c2(offset).b2(byteCount) < 0) {
    throw ArrayIndexOutOfBoundsException.jdd('size=' + size.toString() + ' offset=' + offset.toString() + ' byteCount=' + byteCount.toString());
  }
}
var properties_initialized_Util_kt_13atj0;
function _init_properties_Util_kt__laey5a() {
  if (!properties_initialized_Util_kt_13atj0) {
    properties_initialized_Util_kt_13atj0 = true;
    DEFAULT__new_UnsafeCursor = new UnsafeCursor();
    DEFAULT__ByteString_size = -1234567890;
  }
}
function commonAsUtf8ToByteArray(_this__u8e3s4) {
  var bytes = new Int8Array(imul(4, _this__u8e3s4.length));
  var inductionVariable = 0;
  var last = _this__u8e3s4.length;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b0 = charSequenceGet(_this__u8e3s4, index);
      if (Char__compareTo_impl_ypi4mb(b0, _Char___init__impl__6a9atx(128)) >= 0) {
        var size = index;
        // Inline function 'okio.processUtf8Bytes' call
        var endIndex = _this__u8e3s4.length;
        var index_0 = index;
        while (index_0 < endIndex) {
          var c = charSequenceGet(_this__u8e3s4, index_0);
          if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(128)) < 0) {
            // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
            // Inline function 'kotlin.code' call
            var tmp$ret$0 = Char__toInt_impl_vasixd(c);
            var tmp0 = size;
            size = tmp0 + 1 | 0;
            bytes[tmp0] = toByte(tmp$ret$0);
            index_0 = index_0 + 1 | 0;
            while (index_0 < endIndex && Char__compareTo_impl_ypi4mb(charSequenceGet(_this__u8e3s4, index_0), _Char___init__impl__6a9atx(128)) < 0) {
              // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
              // Inline function 'kotlin.code' call
              var tmp1 = index_0;
              index_0 = tmp1 + 1 | 0;
              var this_0 = charSequenceGet(_this__u8e3s4, tmp1);
              var tmp$ret$1 = Char__toInt_impl_vasixd(this_0);
              var tmp0_0 = size;
              size = tmp0_0 + 1 | 0;
              bytes[tmp0_0] = toByte(tmp$ret$1);
            }
          } else if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(2048)) < 0) {
            // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
            // Inline function 'kotlin.code' call
            var tmp$ret$2 = Char__toInt_impl_vasixd(c);
            var tmp0_1 = size;
            size = tmp0_1 + 1 | 0;
            bytes[tmp0_1] = toByte(tmp$ret$2 >> 6 | 192);
            // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
            // Inline function 'kotlin.code' call
            var tmp$ret$3 = Char__toInt_impl_vasixd(c);
            var tmp0_2 = size;
            size = tmp0_2 + 1 | 0;
            bytes[tmp0_2] = toByte(tmp$ret$3 & 63 | 128);
            index_0 = index_0 + 1 | 0;
          } else if (!(_Char___init__impl__6a9atx(55296) <= c ? c <= _Char___init__impl__6a9atx(57343) : false)) {
            // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
            // Inline function 'kotlin.code' call
            var tmp$ret$4 = Char__toInt_impl_vasixd(c);
            var tmp0_3 = size;
            size = tmp0_3 + 1 | 0;
            bytes[tmp0_3] = toByte(tmp$ret$4 >> 12 | 224);
            // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
            // Inline function 'kotlin.code' call
            var tmp$ret$5 = Char__toInt_impl_vasixd(c);
            var tmp0_4 = size;
            size = tmp0_4 + 1 | 0;
            bytes[tmp0_4] = toByte(tmp$ret$5 >> 6 & 63 | 128);
            // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
            // Inline function 'kotlin.code' call
            var tmp$ret$6 = Char__toInt_impl_vasixd(c);
            var tmp0_5 = size;
            size = tmp0_5 + 1 | 0;
            bytes[tmp0_5] = toByte(tmp$ret$6 & 63 | 128);
            index_0 = index_0 + 1 | 0;
          } else {
            var tmp;
            if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(56319)) > 0 || endIndex <= (index_0 + 1 | 0)) {
              tmp = true;
            } else {
              var containsArg = charSequenceGet(_this__u8e3s4, index_0 + 1 | 0);
              tmp = !(_Char___init__impl__6a9atx(56320) <= containsArg ? containsArg <= _Char___init__impl__6a9atx(57343) : false);
            }
            if (tmp) {
              // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
              var tmp0_6 = size;
              size = tmp0_6 + 1 | 0;
              bytes[tmp0_6] = 63;
              index_0 = index_0 + 1 | 0;
            } else {
              // Inline function 'kotlin.code' call
              var tmp_0 = Char__toInt_impl_vasixd(c) << 10;
              // Inline function 'kotlin.code' call
              var this_1 = charSequenceGet(_this__u8e3s4, index_0 + 1 | 0);
              var codePoint = (tmp_0 + Char__toInt_impl_vasixd(this_1) | 0) + -56613888 | 0;
              // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
              var tmp0_7 = size;
              size = tmp0_7 + 1 | 0;
              bytes[tmp0_7] = toByte(codePoint >> 18 | 240);
              // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
              var tmp0_8 = size;
              size = tmp0_8 + 1 | 0;
              bytes[tmp0_8] = toByte(codePoint >> 12 & 63 | 128);
              // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
              var tmp0_9 = size;
              size = tmp0_9 + 1 | 0;
              bytes[tmp0_9] = toByte(codePoint >> 6 & 63 | 128);
              // Inline function 'okio.internal.commonAsUtf8ToByteArray.<anonymous>' call
              var tmp0_10 = size;
              size = tmp0_10 + 1 | 0;
              bytes[tmp0_10] = toByte(codePoint & 63 | 128);
              index_0 = index_0 + 2 | 0;
            }
          }
        }
        return copyOf(bytes, size);
      }
      // Inline function 'kotlin.code' call
      var tmp$ret$9 = Char__toInt_impl_vasixd(b0);
      bytes[index] = toByte(tmp$ret$9);
    }
     while (inductionVariable < last);
  return copyOf(bytes, _this__u8e3s4.length);
}
function commonToUtf8String(_this__u8e3s4, beginIndex, endIndex) {
  beginIndex = beginIndex === VOID ? 0 : beginIndex;
  endIndex = endIndex === VOID ? _this__u8e3s4.length : endIndex;
  if (beginIndex < 0 || endIndex > _this__u8e3s4.length || beginIndex > endIndex) {
    throw ArrayIndexOutOfBoundsException.jdd('size=' + _this__u8e3s4.length + ' beginIndex=' + beginIndex + ' endIndex=' + endIndex);
  }
  var chars = charArray(endIndex - beginIndex | 0);
  var length = 0;
  // Inline function 'okio.processUtf16Chars' call
  var index = beginIndex;
  while (index < endIndex) {
    var b0 = _this__u8e3s4[index];
    if (b0 >= 0) {
      // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
      var tmp0 = length;
      length = tmp0 + 1 | 0;
      chars[tmp0] = numberToChar(b0);
      index = index + 1 | 0;
      while (index < endIndex && _this__u8e3s4[index] >= 0) {
        // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0_0 = length;
        length = tmp0_0 + 1 | 0;
        chars[tmp0_0] = numberToChar(_this__u8e3s4[tmp1]);
      }
    } else {
      // Inline function 'okio.shr' call
      if (b0 >> 5 === -2) {
        var tmp = index;
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'okio.process2Utf8Bytes' call
          var beginIndex_0 = index;
          if (endIndex <= (beginIndex_0 + 1 | 0)) {
            // Inline function 'okio.processUtf16Chars.<anonymous>' call
            // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
            var tmp0_1 = length;
            length = tmp0_1 + 1 | 0;
            chars[tmp0_1] = numberToChar(65533);
            tmp$ret$1 = 1;
            break $l$block_0;
          }
          var b0_0 = _this__u8e3s4[beginIndex_0];
          var b1 = _this__u8e3s4[beginIndex_0 + 1 | 0];
          // Inline function 'okio.isUtf8Continuation' call
          // Inline function 'okio.and' call
          if (!((b1 & 192) === 128)) {
            // Inline function 'okio.processUtf16Chars.<anonymous>' call
            // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
            var tmp0_2 = length;
            length = tmp0_2 + 1 | 0;
            chars[tmp0_2] = numberToChar(65533);
            tmp$ret$1 = 1;
            break $l$block_0;
          }
          var codePoint = 3968 ^ b1 ^ b0_0 << 6;
          if (codePoint < 128) {
            // Inline function 'okio.processUtf16Chars.<anonymous>' call
            // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
            var tmp0_3 = length;
            length = tmp0_3 + 1 | 0;
            chars[tmp0_3] = numberToChar(65533);
          } else {
            // Inline function 'okio.processUtf16Chars.<anonymous>' call
            // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
            var tmp0_4 = length;
            length = tmp0_4 + 1 | 0;
            chars[tmp0_4] = numberToChar(codePoint);
          }
          tmp$ret$1 = 2;
        }
        index = tmp + tmp$ret$1 | 0;
      } else {
        // Inline function 'okio.shr' call
        if (b0 >> 4 === -2) {
          var tmp_0 = index;
          var tmp$ret$7;
          $l$block_4: {
            // Inline function 'okio.process3Utf8Bytes' call
            var beginIndex_1 = index;
            if (endIndex <= (beginIndex_1 + 2 | 0)) {
              // Inline function 'okio.processUtf16Chars.<anonymous>' call
              // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
              var tmp0_5 = length;
              length = tmp0_5 + 1 | 0;
              chars[tmp0_5] = numberToChar(65533);
              var tmp_1;
              if (endIndex <= (beginIndex_1 + 1 | 0)) {
                tmp_1 = true;
              } else {
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                tmp_1 = !((_this__u8e3s4[beginIndex_1 + 1 | 0] & 192) === 128);
              }
              if (tmp_1) {
                tmp$ret$7 = 1;
                break $l$block_4;
              } else {
                tmp$ret$7 = 2;
                break $l$block_4;
              }
            }
            var b0_1 = _this__u8e3s4[beginIndex_1];
            var b1_0 = _this__u8e3s4[beginIndex_1 + 1 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b1_0 & 192) === 128)) {
              // Inline function 'okio.processUtf16Chars.<anonymous>' call
              // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
              var tmp0_6 = length;
              length = tmp0_6 + 1 | 0;
              chars[tmp0_6] = numberToChar(65533);
              tmp$ret$7 = 1;
              break $l$block_4;
            }
            var b2 = _this__u8e3s4[beginIndex_1 + 2 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b2 & 192) === 128)) {
              // Inline function 'okio.processUtf16Chars.<anonymous>' call
              // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
              var tmp0_7 = length;
              length = tmp0_7 + 1 | 0;
              chars[tmp0_7] = numberToChar(65533);
              tmp$ret$7 = 2;
              break $l$block_4;
            }
            var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
            if (codePoint_0 < 2048) {
              // Inline function 'okio.processUtf16Chars.<anonymous>' call
              // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
              var tmp0_8 = length;
              length = tmp0_8 + 1 | 0;
              chars[tmp0_8] = numberToChar(65533);
            } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
              // Inline function 'okio.processUtf16Chars.<anonymous>' call
              // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
              var tmp0_9 = length;
              length = tmp0_9 + 1 | 0;
              chars[tmp0_9] = numberToChar(65533);
            } else {
              // Inline function 'okio.processUtf16Chars.<anonymous>' call
              // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
              var tmp0_10 = length;
              length = tmp0_10 + 1 | 0;
              chars[tmp0_10] = numberToChar(codePoint_0);
            }
            tmp$ret$7 = 3;
          }
          index = tmp_0 + tmp$ret$7 | 0;
        } else {
          // Inline function 'okio.shr' call
          if (b0 >> 3 === -2) {
            var tmp_2 = index;
            var tmp$ret$15;
            $l$block_10: {
              // Inline function 'okio.process4Utf8Bytes' call
              var beginIndex_2 = index;
              if (endIndex <= (beginIndex_2 + 3 | 0)) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_11 = length;
                  length = tmp0_11 + 1 | 0;
                  chars[tmp0_11] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_12 = length;
                  length = tmp0_12 + 1 | 0;
                  chars[tmp0_12] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_13 = length;
                  length = tmp0_13 + 1 | 0;
                  chars[tmp0_13] = _Char___init__impl__6a9atx(65533);
                }
                var tmp_3;
                if (endIndex <= (beginIndex_2 + 1 | 0)) {
                  tmp_3 = true;
                } else {
                  // Inline function 'okio.isUtf8Continuation' call
                  // Inline function 'okio.and' call
                  tmp_3 = !((_this__u8e3s4[beginIndex_2 + 1 | 0] & 192) === 128);
                }
                if (tmp_3) {
                  tmp$ret$15 = 1;
                  break $l$block_10;
                } else {
                  var tmp_4;
                  if (endIndex <= (beginIndex_2 + 2 | 0)) {
                    tmp_4 = true;
                  } else {
                    // Inline function 'okio.isUtf8Continuation' call
                    // Inline function 'okio.and' call
                    tmp_4 = !((_this__u8e3s4[beginIndex_2 + 2 | 0] & 192) === 128);
                  }
                  if (tmp_4) {
                    tmp$ret$15 = 2;
                    break $l$block_10;
                  } else {
                    tmp$ret$15 = 3;
                    break $l$block_10;
                  }
                }
              }
              var b0_2 = _this__u8e3s4[beginIndex_2];
              var b1_1 = _this__u8e3s4[beginIndex_2 + 1 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b1_1 & 192) === 128)) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_14 = length;
                  length = tmp0_14 + 1 | 0;
                  chars[tmp0_14] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_15 = length;
                  length = tmp0_15 + 1 | 0;
                  chars[tmp0_15] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_16 = length;
                  length = tmp0_16 + 1 | 0;
                  chars[tmp0_16] = _Char___init__impl__6a9atx(65533);
                }
                tmp$ret$15 = 1;
                break $l$block_10;
              }
              var b2_0 = _this__u8e3s4[beginIndex_2 + 2 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b2_0 & 192) === 128)) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_17 = length;
                  length = tmp0_17 + 1 | 0;
                  chars[tmp0_17] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_18 = length;
                  length = tmp0_18 + 1 | 0;
                  chars[tmp0_18] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_19 = length;
                  length = tmp0_19 + 1 | 0;
                  chars[tmp0_19] = _Char___init__impl__6a9atx(65533);
                }
                tmp$ret$15 = 2;
                break $l$block_10;
              }
              var b3 = _this__u8e3s4[beginIndex_2 + 3 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b3 & 192) === 128)) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_20 = length;
                  length = tmp0_20 + 1 | 0;
                  chars[tmp0_20] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_21 = length;
                  length = tmp0_21 + 1 | 0;
                  chars[tmp0_21] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_22 = length;
                  length = tmp0_22 + 1 | 0;
                  chars[tmp0_22] = _Char___init__impl__6a9atx(65533);
                }
                tmp$ret$15 = 3;
                break $l$block_10;
              }
              var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
              if (codePoint_1 > 1114111) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_23 = length;
                  length = tmp0_23 + 1 | 0;
                  chars[tmp0_23] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_24 = length;
                  length = tmp0_24 + 1 | 0;
                  chars[tmp0_24] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_25 = length;
                  length = tmp0_25 + 1 | 0;
                  chars[tmp0_25] = _Char___init__impl__6a9atx(65533);
                }
              } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_26 = length;
                  length = tmp0_26 + 1 | 0;
                  chars[tmp0_26] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_27 = length;
                  length = tmp0_27 + 1 | 0;
                  chars[tmp0_27] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_28 = length;
                  length = tmp0_28 + 1 | 0;
                  chars[tmp0_28] = _Char___init__impl__6a9atx(65533);
                }
              } else if (codePoint_1 < 65536) {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(65533 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_29 = length;
                  length = tmp0_29 + 1 | 0;
                  chars[tmp0_29] = numberToChar((65533 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_30 = length;
                  length = tmp0_30 + 1 | 0;
                  chars[tmp0_30] = numberToChar((65533 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_31 = length;
                  length = tmp0_31 + 1 | 0;
                  chars[tmp0_31] = _Char___init__impl__6a9atx(65533);
                }
              } else {
                // Inline function 'okio.processUtf16Chars.<anonymous>' call
                if (!(codePoint_1 === 65533)) {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_32 = length;
                  length = tmp0_32 + 1 | 0;
                  chars[tmp0_32] = numberToChar((codePoint_1 >>> 10 | 0) + 55232 | 0);
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_33 = length;
                  length = tmp0_33 + 1 | 0;
                  chars[tmp0_33] = numberToChar((codePoint_1 & 1023) + 56320 | 0);
                } else {
                  // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
                  var tmp0_34 = length;
                  length = tmp0_34 + 1 | 0;
                  chars[tmp0_34] = _Char___init__impl__6a9atx(65533);
                }
              }
              tmp$ret$15 = 4;
            }
            index = tmp_2 + tmp$ret$15 | 0;
          } else {
            // Inline function 'okio.internal.commonToUtf8String.<anonymous>' call
            var tmp0_35 = length;
            length = tmp0_35 + 1 | 0;
            chars[tmp0_35] = _Char___init__impl__6a9atx(65533);
            index = index + 1 | 0;
          }
        }
      }
    }
  }
  return concatToString(chars, 0, length);
}
function get_HEX_DIGIT_CHARS() {
  _init_properties_ByteString_kt__sqjq7b();
  return HEX_DIGIT_CHARS;
}
var HEX_DIGIT_CHARS;
function commonWrite(_this__u8e3s4, buffer, offset, byteCount) {
  _init_properties_ByteString_kt__sqjq7b();
  buffer.v2d(_this__u8e3s4.cdd_1, offset, byteCount);
}
function codePointIndexToCharIndex(s, codePointCount) {
  _init_properties_ByteString_kt__sqjq7b();
  var charCount = 0;
  var j = 0;
  // Inline function 'okio.processUtf8CodePoints' call
  var endIndex = s.length;
  var index = 0;
  while (index < endIndex) {
    var b0 = s[index];
    if (b0 >= 0) {
      // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
      var tmp0 = j;
      j = tmp0 + 1 | 0;
      if (tmp0 === codePointCount) {
        return charCount;
      }
      var tmp;
      var tmp_0;
      var tmp_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (!(b0 === Char__toInt_impl_vasixd(this_0))) {
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(13);
        tmp_1 = !(b0 === Char__toInt_impl_vasixd(this_1));
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        // Inline function 'okio.isIsoControl' call
        tmp_0 = (0 <= b0 ? b0 <= 31 : false) || (127 <= b0 ? b0 <= 159 : false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp = true;
      } else {
        tmp = b0 === 65533;
      }
      if (tmp) {
        return -1;
      }
      charCount = charCount + (b0 < 65536 ? 1 : 2) | 0;
      index = index + 1 | 0;
      while (index < endIndex && s[index] >= 0) {
        // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var c = s[tmp1];
        var tmp0_0 = j;
        j = tmp0_0 + 1 | 0;
        if (tmp0_0 === codePointCount) {
          return charCount;
        }
        var tmp_2;
        var tmp_3;
        var tmp_4;
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(10);
        if (!(c === Char__toInt_impl_vasixd(this_2))) {
          // Inline function 'kotlin.code' call
          var this_3 = _Char___init__impl__6a9atx(13);
          tmp_4 = !(c === Char__toInt_impl_vasixd(this_3));
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          // Inline function 'okio.isIsoControl' call
          tmp_3 = (0 <= c ? c <= 31 : false) || (127 <= c ? c <= 159 : false);
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp_2 = true;
        } else {
          tmp_2 = c === 65533;
        }
        if (tmp_2) {
          return -1;
        }
        charCount = charCount + (c < 65536 ? 1 : 2) | 0;
      }
    } else {
      // Inline function 'okio.shr' call
      if (b0 >> 5 === -2) {
        var tmp_5 = index;
        var tmp$ret$10;
        $l$block_0: {
          // Inline function 'okio.process2Utf8Bytes' call
          var beginIndex = index;
          if (endIndex <= (beginIndex + 1 | 0)) {
            // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
            // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
            var tmp0_1 = j;
            j = tmp0_1 + 1 | 0;
            if (tmp0_1 === codePointCount) {
              return charCount;
            }
            var tmp_6;
            var tmp_7;
            var tmp_8;
            // Inline function 'kotlin.code' call
            var this_4 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_4))) {
              // Inline function 'kotlin.code' call
              var this_5 = _Char___init__impl__6a9atx(13);
              tmp_8 = !(65533 === Char__toInt_impl_vasixd(this_5));
            } else {
              tmp_8 = false;
            }
            if (tmp_8) {
              // Inline function 'okio.isIsoControl' call
              tmp_7 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_7 = false;
            }
            if (tmp_7) {
              tmp_6 = true;
            } else {
              tmp_6 = 65533 === 65533;
            }
            if (tmp_6) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            tmp$ret$10 = 1;
            break $l$block_0;
          }
          var b0_0 = s[beginIndex];
          var b1 = s[beginIndex + 1 | 0];
          // Inline function 'okio.isUtf8Continuation' call
          // Inline function 'okio.and' call
          if (!((b1 & 192) === 128)) {
            // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
            // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
            var tmp0_2 = j;
            j = tmp0_2 + 1 | 0;
            if (tmp0_2 === codePointCount) {
              return charCount;
            }
            var tmp_9;
            var tmp_10;
            var tmp_11;
            // Inline function 'kotlin.code' call
            var this_6 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_6))) {
              // Inline function 'kotlin.code' call
              var this_7 = _Char___init__impl__6a9atx(13);
              tmp_11 = !(65533 === Char__toInt_impl_vasixd(this_7));
            } else {
              tmp_11 = false;
            }
            if (tmp_11) {
              // Inline function 'okio.isIsoControl' call
              tmp_10 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_10 = false;
            }
            if (tmp_10) {
              tmp_9 = true;
            } else {
              tmp_9 = 65533 === 65533;
            }
            if (tmp_9) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            tmp$ret$10 = 1;
            break $l$block_0;
          }
          var codePoint = 3968 ^ b1 ^ b0_0 << 6;
          if (codePoint < 128) {
            // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
            // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
            var tmp0_3 = j;
            j = tmp0_3 + 1 | 0;
            if (tmp0_3 === codePointCount) {
              return charCount;
            }
            var tmp_12;
            var tmp_13;
            var tmp_14;
            // Inline function 'kotlin.code' call
            var this_8 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_8))) {
              // Inline function 'kotlin.code' call
              var this_9 = _Char___init__impl__6a9atx(13);
              tmp_14 = !(65533 === Char__toInt_impl_vasixd(this_9));
            } else {
              tmp_14 = false;
            }
            if (tmp_14) {
              // Inline function 'okio.isIsoControl' call
              tmp_13 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_13 = false;
            }
            if (tmp_13) {
              tmp_12 = true;
            } else {
              tmp_12 = 65533 === 65533;
            }
            if (tmp_12) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
          } else {
            // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
            // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
            var tmp0_4 = j;
            j = tmp0_4 + 1 | 0;
            if (tmp0_4 === codePointCount) {
              return charCount;
            }
            var tmp_15;
            var tmp_16;
            var tmp_17;
            // Inline function 'kotlin.code' call
            var this_10 = _Char___init__impl__6a9atx(10);
            if (!(codePoint === Char__toInt_impl_vasixd(this_10))) {
              // Inline function 'kotlin.code' call
              var this_11 = _Char___init__impl__6a9atx(13);
              tmp_17 = !(codePoint === Char__toInt_impl_vasixd(this_11));
            } else {
              tmp_17 = false;
            }
            if (tmp_17) {
              // Inline function 'okio.isIsoControl' call
              tmp_16 = (0 <= codePoint ? codePoint <= 31 : false) || (127 <= codePoint ? codePoint <= 159 : false);
            } else {
              tmp_16 = false;
            }
            if (tmp_16) {
              tmp_15 = true;
            } else {
              tmp_15 = codePoint === 65533;
            }
            if (tmp_15) {
              return -1;
            }
            charCount = charCount + (codePoint < 65536 ? 1 : 2) | 0;
          }
          tmp$ret$10 = 2;
        }
        index = tmp_5 + tmp$ret$10 | 0;
      } else {
        // Inline function 'okio.shr' call
        if (b0 >> 4 === -2) {
          var tmp_18 = index;
          var tmp$ret$28;
          $l$block_4: {
            // Inline function 'okio.process3Utf8Bytes' call
            var beginIndex_0 = index;
            if (endIndex <= (beginIndex_0 + 2 | 0)) {
              // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
              // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
              var tmp0_5 = j;
              j = tmp0_5 + 1 | 0;
              if (tmp0_5 === codePointCount) {
                return charCount;
              }
              var tmp_19;
              var tmp_20;
              var tmp_21;
              // Inline function 'kotlin.code' call
              var this_12 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_12))) {
                // Inline function 'kotlin.code' call
                var this_13 = _Char___init__impl__6a9atx(13);
                tmp_21 = !(65533 === Char__toInt_impl_vasixd(this_13));
              } else {
                tmp_21 = false;
              }
              if (tmp_21) {
                // Inline function 'okio.isIsoControl' call
                tmp_20 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_20 = false;
              }
              if (tmp_20) {
                tmp_19 = true;
              } else {
                tmp_19 = 65533 === 65533;
              }
              if (tmp_19) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              var tmp_22;
              if (endIndex <= (beginIndex_0 + 1 | 0)) {
                tmp_22 = true;
              } else {
                // Inline function 'okio.isUtf8Continuation' call
                // Inline function 'okio.and' call
                tmp_22 = !((s[beginIndex_0 + 1 | 0] & 192) === 128);
              }
              if (tmp_22) {
                tmp$ret$28 = 1;
                break $l$block_4;
              } else {
                tmp$ret$28 = 2;
                break $l$block_4;
              }
            }
            var b0_1 = s[beginIndex_0];
            var b1_0 = s[beginIndex_0 + 1 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b1_0 & 192) === 128)) {
              // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
              // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
              var tmp0_6 = j;
              j = tmp0_6 + 1 | 0;
              if (tmp0_6 === codePointCount) {
                return charCount;
              }
              var tmp_23;
              var tmp_24;
              var tmp_25;
              // Inline function 'kotlin.code' call
              var this_14 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_14))) {
                // Inline function 'kotlin.code' call
                var this_15 = _Char___init__impl__6a9atx(13);
                tmp_25 = !(65533 === Char__toInt_impl_vasixd(this_15));
              } else {
                tmp_25 = false;
              }
              if (tmp_25) {
                // Inline function 'okio.isIsoControl' call
                tmp_24 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_24 = false;
              }
              if (tmp_24) {
                tmp_23 = true;
              } else {
                tmp_23 = 65533 === 65533;
              }
              if (tmp_23) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              tmp$ret$28 = 1;
              break $l$block_4;
            }
            var b2 = s[beginIndex_0 + 2 | 0];
            // Inline function 'okio.isUtf8Continuation' call
            // Inline function 'okio.and' call
            if (!((b2 & 192) === 128)) {
              // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
              // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
              var tmp0_7 = j;
              j = tmp0_7 + 1 | 0;
              if (tmp0_7 === codePointCount) {
                return charCount;
              }
              var tmp_26;
              var tmp_27;
              var tmp_28;
              // Inline function 'kotlin.code' call
              var this_16 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_16))) {
                // Inline function 'kotlin.code' call
                var this_17 = _Char___init__impl__6a9atx(13);
                tmp_28 = !(65533 === Char__toInt_impl_vasixd(this_17));
              } else {
                tmp_28 = false;
              }
              if (tmp_28) {
                // Inline function 'okio.isIsoControl' call
                tmp_27 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_27 = false;
              }
              if (tmp_27) {
                tmp_26 = true;
              } else {
                tmp_26 = 65533 === 65533;
              }
              if (tmp_26) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              tmp$ret$28 = 2;
              break $l$block_4;
            }
            var codePoint_0 = -123008 ^ b2 ^ b1_0 << 6 ^ b0_1 << 12;
            if (codePoint_0 < 2048) {
              // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
              // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
              var tmp0_8 = j;
              j = tmp0_8 + 1 | 0;
              if (tmp0_8 === codePointCount) {
                return charCount;
              }
              var tmp_29;
              var tmp_30;
              var tmp_31;
              // Inline function 'kotlin.code' call
              var this_18 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_18))) {
                // Inline function 'kotlin.code' call
                var this_19 = _Char___init__impl__6a9atx(13);
                tmp_31 = !(65533 === Char__toInt_impl_vasixd(this_19));
              } else {
                tmp_31 = false;
              }
              if (tmp_31) {
                // Inline function 'okio.isIsoControl' call
                tmp_30 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_30 = false;
              }
              if (tmp_30) {
                tmp_29 = true;
              } else {
                tmp_29 = 65533 === 65533;
              }
              if (tmp_29) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            } else if (55296 <= codePoint_0 ? codePoint_0 <= 57343 : false) {
              // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
              // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
              var tmp0_9 = j;
              j = tmp0_9 + 1 | 0;
              if (tmp0_9 === codePointCount) {
                return charCount;
              }
              var tmp_32;
              var tmp_33;
              var tmp_34;
              // Inline function 'kotlin.code' call
              var this_20 = _Char___init__impl__6a9atx(10);
              if (!(65533 === Char__toInt_impl_vasixd(this_20))) {
                // Inline function 'kotlin.code' call
                var this_21 = _Char___init__impl__6a9atx(13);
                tmp_34 = !(65533 === Char__toInt_impl_vasixd(this_21));
              } else {
                tmp_34 = false;
              }
              if (tmp_34) {
                // Inline function 'okio.isIsoControl' call
                tmp_33 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
              } else {
                tmp_33 = false;
              }
              if (tmp_33) {
                tmp_32 = true;
              } else {
                tmp_32 = 65533 === 65533;
              }
              if (tmp_32) {
                return -1;
              }
              charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            } else {
              // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
              // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
              var tmp0_10 = j;
              j = tmp0_10 + 1 | 0;
              if (tmp0_10 === codePointCount) {
                return charCount;
              }
              var tmp_35;
              var tmp_36;
              var tmp_37;
              // Inline function 'kotlin.code' call
              var this_22 = _Char___init__impl__6a9atx(10);
              if (!(codePoint_0 === Char__toInt_impl_vasixd(this_22))) {
                // Inline function 'kotlin.code' call
                var this_23 = _Char___init__impl__6a9atx(13);
                tmp_37 = !(codePoint_0 === Char__toInt_impl_vasixd(this_23));
              } else {
                tmp_37 = false;
              }
              if (tmp_37) {
                // Inline function 'okio.isIsoControl' call
                tmp_36 = (0 <= codePoint_0 ? codePoint_0 <= 31 : false) || (127 <= codePoint_0 ? codePoint_0 <= 159 : false);
              } else {
                tmp_36 = false;
              }
              if (tmp_36) {
                tmp_35 = true;
              } else {
                tmp_35 = codePoint_0 === 65533;
              }
              if (tmp_35) {
                return -1;
              }
              charCount = charCount + (codePoint_0 < 65536 ? 1 : 2) | 0;
            }
            tmp$ret$28 = 3;
          }
          index = tmp_18 + tmp$ret$28 | 0;
        } else {
          // Inline function 'okio.shr' call
          if (b0 >> 3 === -2) {
            var tmp_38 = index;
            var tmp$ret$54;
            $l$block_10: {
              // Inline function 'okio.process4Utf8Bytes' call
              var beginIndex_1 = index;
              if (endIndex <= (beginIndex_1 + 3 | 0)) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_11 = j;
                j = tmp0_11 + 1 | 0;
                if (tmp0_11 === codePointCount) {
                  return charCount;
                }
                var tmp_39;
                var tmp_40;
                var tmp_41;
                // Inline function 'kotlin.code' call
                var this_24 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_24))) {
                  // Inline function 'kotlin.code' call
                  var this_25 = _Char___init__impl__6a9atx(13);
                  tmp_41 = !(65533 === Char__toInt_impl_vasixd(this_25));
                } else {
                  tmp_41 = false;
                }
                if (tmp_41) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_40 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_40 = false;
                }
                if (tmp_40) {
                  tmp_39 = true;
                } else {
                  tmp_39 = 65533 === 65533;
                }
                if (tmp_39) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                var tmp_42;
                if (endIndex <= (beginIndex_1 + 1 | 0)) {
                  tmp_42 = true;
                } else {
                  // Inline function 'okio.isUtf8Continuation' call
                  // Inline function 'okio.and' call
                  tmp_42 = !((s[beginIndex_1 + 1 | 0] & 192) === 128);
                }
                if (tmp_42) {
                  tmp$ret$54 = 1;
                  break $l$block_10;
                } else {
                  var tmp_43;
                  if (endIndex <= (beginIndex_1 + 2 | 0)) {
                    tmp_43 = true;
                  } else {
                    // Inline function 'okio.isUtf8Continuation' call
                    // Inline function 'okio.and' call
                    tmp_43 = !((s[beginIndex_1 + 2 | 0] & 192) === 128);
                  }
                  if (tmp_43) {
                    tmp$ret$54 = 2;
                    break $l$block_10;
                  } else {
                    tmp$ret$54 = 3;
                    break $l$block_10;
                  }
                }
              }
              var b0_2 = s[beginIndex_1];
              var b1_1 = s[beginIndex_1 + 1 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b1_1 & 192) === 128)) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_12 = j;
                j = tmp0_12 + 1 | 0;
                if (tmp0_12 === codePointCount) {
                  return charCount;
                }
                var tmp_44;
                var tmp_45;
                var tmp_46;
                // Inline function 'kotlin.code' call
                var this_26 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_26))) {
                  // Inline function 'kotlin.code' call
                  var this_27 = _Char___init__impl__6a9atx(13);
                  tmp_46 = !(65533 === Char__toInt_impl_vasixd(this_27));
                } else {
                  tmp_46 = false;
                }
                if (tmp_46) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_45 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_45 = false;
                }
                if (tmp_45) {
                  tmp_44 = true;
                } else {
                  tmp_44 = 65533 === 65533;
                }
                if (tmp_44) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$54 = 1;
                break $l$block_10;
              }
              var b2_0 = s[beginIndex_1 + 2 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b2_0 & 192) === 128)) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_13 = j;
                j = tmp0_13 + 1 | 0;
                if (tmp0_13 === codePointCount) {
                  return charCount;
                }
                var tmp_47;
                var tmp_48;
                var tmp_49;
                // Inline function 'kotlin.code' call
                var this_28 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_28))) {
                  // Inline function 'kotlin.code' call
                  var this_29 = _Char___init__impl__6a9atx(13);
                  tmp_49 = !(65533 === Char__toInt_impl_vasixd(this_29));
                } else {
                  tmp_49 = false;
                }
                if (tmp_49) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_48 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_48 = false;
                }
                if (tmp_48) {
                  tmp_47 = true;
                } else {
                  tmp_47 = 65533 === 65533;
                }
                if (tmp_47) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$54 = 2;
                break $l$block_10;
              }
              var b3 = s[beginIndex_1 + 3 | 0];
              // Inline function 'okio.isUtf8Continuation' call
              // Inline function 'okio.and' call
              if (!((b3 & 192) === 128)) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_14 = j;
                j = tmp0_14 + 1 | 0;
                if (tmp0_14 === codePointCount) {
                  return charCount;
                }
                var tmp_50;
                var tmp_51;
                var tmp_52;
                // Inline function 'kotlin.code' call
                var this_30 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_30))) {
                  // Inline function 'kotlin.code' call
                  var this_31 = _Char___init__impl__6a9atx(13);
                  tmp_52 = !(65533 === Char__toInt_impl_vasixd(this_31));
                } else {
                  tmp_52 = false;
                }
                if (tmp_52) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_51 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_51 = false;
                }
                if (tmp_51) {
                  tmp_50 = true;
                } else {
                  tmp_50 = 65533 === 65533;
                }
                if (tmp_50) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
                tmp$ret$54 = 3;
                break $l$block_10;
              }
              var codePoint_1 = 3678080 ^ b3 ^ b2_0 << 6 ^ b1_1 << 12 ^ b0_2 << 18;
              if (codePoint_1 > 1114111) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_15 = j;
                j = tmp0_15 + 1 | 0;
                if (tmp0_15 === codePointCount) {
                  return charCount;
                }
                var tmp_53;
                var tmp_54;
                var tmp_55;
                // Inline function 'kotlin.code' call
                var this_32 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_32))) {
                  // Inline function 'kotlin.code' call
                  var this_33 = _Char___init__impl__6a9atx(13);
                  tmp_55 = !(65533 === Char__toInt_impl_vasixd(this_33));
                } else {
                  tmp_55 = false;
                }
                if (tmp_55) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_54 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_54 = false;
                }
                if (tmp_54) {
                  tmp_53 = true;
                } else {
                  tmp_53 = 65533 === 65533;
                }
                if (tmp_53) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else if (55296 <= codePoint_1 ? codePoint_1 <= 57343 : false) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_16 = j;
                j = tmp0_16 + 1 | 0;
                if (tmp0_16 === codePointCount) {
                  return charCount;
                }
                var tmp_56;
                var tmp_57;
                var tmp_58;
                // Inline function 'kotlin.code' call
                var this_34 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_34))) {
                  // Inline function 'kotlin.code' call
                  var this_35 = _Char___init__impl__6a9atx(13);
                  tmp_58 = !(65533 === Char__toInt_impl_vasixd(this_35));
                } else {
                  tmp_58 = false;
                }
                if (tmp_58) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_57 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_57 = false;
                }
                if (tmp_57) {
                  tmp_56 = true;
                } else {
                  tmp_56 = 65533 === 65533;
                }
                if (tmp_56) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else if (codePoint_1 < 65536) {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_17 = j;
                j = tmp0_17 + 1 | 0;
                if (tmp0_17 === codePointCount) {
                  return charCount;
                }
                var tmp_59;
                var tmp_60;
                var tmp_61;
                // Inline function 'kotlin.code' call
                var this_36 = _Char___init__impl__6a9atx(10);
                if (!(65533 === Char__toInt_impl_vasixd(this_36))) {
                  // Inline function 'kotlin.code' call
                  var this_37 = _Char___init__impl__6a9atx(13);
                  tmp_61 = !(65533 === Char__toInt_impl_vasixd(this_37));
                } else {
                  tmp_61 = false;
                }
                if (tmp_61) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_60 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
                } else {
                  tmp_60 = false;
                }
                if (tmp_60) {
                  tmp_59 = true;
                } else {
                  tmp_59 = 65533 === 65533;
                }
                if (tmp_59) {
                  return -1;
                }
                charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
              } else {
                // Inline function 'okio.processUtf8CodePoints.<anonymous>' call
                // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
                var tmp0_18 = j;
                j = tmp0_18 + 1 | 0;
                if (tmp0_18 === codePointCount) {
                  return charCount;
                }
                var tmp_62;
                var tmp_63;
                var tmp_64;
                // Inline function 'kotlin.code' call
                var this_38 = _Char___init__impl__6a9atx(10);
                if (!(codePoint_1 === Char__toInt_impl_vasixd(this_38))) {
                  // Inline function 'kotlin.code' call
                  var this_39 = _Char___init__impl__6a9atx(13);
                  tmp_64 = !(codePoint_1 === Char__toInt_impl_vasixd(this_39));
                } else {
                  tmp_64 = false;
                }
                if (tmp_64) {
                  // Inline function 'okio.isIsoControl' call
                  tmp_63 = (0 <= codePoint_1 ? codePoint_1 <= 31 : false) || (127 <= codePoint_1 ? codePoint_1 <= 159 : false);
                } else {
                  tmp_63 = false;
                }
                if (tmp_63) {
                  tmp_62 = true;
                } else {
                  tmp_62 = codePoint_1 === 65533;
                }
                if (tmp_62) {
                  return -1;
                }
                charCount = charCount + (codePoint_1 < 65536 ? 1 : 2) | 0;
              }
              tmp$ret$54 = 4;
            }
            index = tmp_38 + tmp$ret$54 | 0;
          } else {
            // Inline function 'okio.internal.codePointIndexToCharIndex.<anonymous>' call
            var tmp0_19 = j;
            j = tmp0_19 + 1 | 0;
            if (tmp0_19 === codePointCount) {
              return charCount;
            }
            var tmp_65;
            var tmp_66;
            var tmp_67;
            // Inline function 'kotlin.code' call
            var this_40 = _Char___init__impl__6a9atx(10);
            if (!(65533 === Char__toInt_impl_vasixd(this_40))) {
              // Inline function 'kotlin.code' call
              var this_41 = _Char___init__impl__6a9atx(13);
              tmp_67 = !(65533 === Char__toInt_impl_vasixd(this_41));
            } else {
              tmp_67 = false;
            }
            if (tmp_67) {
              // Inline function 'okio.isIsoControl' call
              tmp_66 = (0 <= 65533 ? 65533 <= 31 : false) || (127 <= 65533 ? 65533 <= 159 : false);
            } else {
              tmp_66 = false;
            }
            if (tmp_66) {
              tmp_65 = true;
            } else {
              tmp_65 = 65533 === 65533;
            }
            if (tmp_65) {
              return -1;
            }
            charCount = charCount + (65533 < 65536 ? 1 : 2) | 0;
            index = index + 1 | 0;
          }
        }
      }
    }
  }
  return charCount;
}
function codePointIndexToCharIndex$accessor$1yfvj6b(s, codePointCount) {
  _init_properties_ByteString_kt__sqjq7b();
  return codePointIndexToCharIndex(s, codePointCount);
}
var properties_initialized_ByteString_kt_8ybv8b;
function _init_properties_ByteString_kt__sqjq7b() {
  if (!properties_initialized_ByteString_kt_8ybv8b) {
    properties_initialized_ByteString_kt_8ybv8b = true;
    // Inline function 'kotlin.charArrayOf' call
    HEX_DIGIT_CHARS = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(98), _Char___init__impl__6a9atx(99), _Char___init__impl__6a9atx(100), _Char___init__impl__6a9atx(101), _Char___init__impl__6a9atx(102)]);
  }
}
function segment(_this__u8e3s4, pos) {
  var i = binarySearch(_this__u8e3s4.qdd_1, pos + 1 | 0, 0, _this__u8e3s4.pdd_1.length);
  return i >= 0 ? i : ~i;
}
function binarySearch(_this__u8e3s4, value, fromIndex, toIndex) {
  var left = fromIndex;
  var right = toIndex - 1 | 0;
  while (left <= right) {
    var mid = (left + right | 0) >>> 1 | 0;
    var midVal = _this__u8e3s4[mid];
    if (midVal < value)
      left = mid + 1 | 0;
    else if (midVal > value)
      right = mid - 1 | 0;
    else
      return mid;
  }
  return (-left | 0) - 1 | 0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function toByteString($this) {
  return new ByteString($this.v22());
}
function asUtf8ToByteArray(_this__u8e3s4) {
  return commonAsUtf8ToByteArray(_this__u8e3s4);
}
function toUtf8String(_this__u8e3s4) {
  return commonToUtf8String(_this__u8e3s4);
}
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Segment, 'Segment', Segment.qdc);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ByteString, 'ByteString', VOID, VOID, [Comparable]);
initMetadataForClass(SegmentedByteString, 'SegmentedByteString');
initMetadataForClass(UnsafeCursor, 'UnsafeCursor', UnsafeCursor);
initMetadataForInterface(BufferedSource, 'BufferedSource');
initMetadataForClass(Buffer, 'Buffer', Buffer, VOID, [BufferedSource]);
initMetadataForClass(ArrayIndexOutOfBoundsException, 'ArrayIndexOutOfBoundsException');
initMetadataForClass(IOException, 'IOException', IOException.idf);
initMetadataForClass(EOFException, 'EOFException', EOFException.qde);
initMetadataForClass(RealBufferedSource, 'RealBufferedSource', VOID, VOID, [BufferedSource]);
initMetadataForObject(SegmentPool, 'SegmentPool');
//endregion
//region block: init
Companion_instance = new Companion();
SegmentPool_instance = new SegmentPool();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance3qk4c089etcnv,
  BufferedSource as BufferedSource3ezj4539oep1e,
  Buffer as Buffer3384y49aj0pxr,
  IOException as IOException3fje1ukjwthwb,
  buffer as bufferbiiev5vr4b6f,
};
//endregion
